"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PlatformDataHydrator {
    constructor({ platform, resolveAnonymousIdFn, resolveSessionIdFn, resolveContactIdFn, resolveProductDataFn, resolveSplitTestDataFn, }) {
        this.platform = platform;
        this.resolveAnonymousIdFn = resolveAnonymousIdFn;
        this.resolveSessionIdFn = resolveSessionIdFn;
        this.resolveContactIdFn = resolveContactIdFn;
        this.resolveProductDataFn = resolveProductDataFn;
        this.resolveSplitTestDataFn = resolveSplitTestDataFn;
    }
    resolvePlatform() {
        return this.platform;
    }
    resolveAnonymousId() {
        return this.resolveAnonymousIdFn();
    }
    resolveContactId() {
        return this.resolveContactIdFn();
    }
    resolveSessionId() {
        return this.resolveSessionIdFn();
    }
    resolveProductData() {
        return this.resolveProductDataFn();
    }
    resolveSplitTestData() {
        return this.resolveSplitTestDataFn();
    }
}
exports.default = PlatformDataHydrator;
